/** Split pasted text into voucher codes: one per line (commas, semicolons and tabs also separate), trimmed, de-duplicated. */
export function parseVoucherCodes(text: string): string[] {
  const codes = text
    .split(/[\r\n,;\t]+/)
    .map((code) => code.trim().replace(/^["']|["']$/g, '').trim())
    .filter((code) => code && !/^(coupon |discount |voucher )?codes?$/i.test(code));
  return [...new Set(codes)];
}

/** First column of each line in a CSV or text file. */
export function voucherCodeLinesFromFile(text: string): string[] {
  return text.split(/\r?\n/).map((line) => line.split(/[,;\t]/)[0] ?? '');
}
